import { render, staticRenderFns } from "./Precheck.vue?vue&type=template&id=ddebc0c8&scoped=true&"
import script from "./Precheck.vue?vue&type=script&lang=js&"
export * from "./Precheck.vue?vue&type=script&lang=js&"
import style0 from "./Precheck.vue?vue&type=style&index=0&id=ddebc0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddebc0c8",
  null
  
)

export default component.exports